import { 
	EEnv,
	EFinaceToggleTypes,
	EFrameType,
	EImageExtensions, 
	EOfferType, 
	ESpecialItemDisclaimerTypes, 
	EToggles
} from '@/enums';
import { 
	IVehicle,
	IVehicleImage,
	IVehicleImage360,
	IVehicleImageHero,
	IFakeColourElements,
	IFakePaintEl,
	IFakeTrimEl,
	IFakeRoofEl,
	ICodes,
	INewSwatchData,
	ITimePickerVal,
	IOpeningInfoItem,
	IEnabledTimes,
	IVehiclePricing,
	IAdvantageDataItem,
	ITestDriveOption,
	IWindowScripts,
	IVehicleImages,
	INewDisclaimer,
	IRoots,
	ITree,
	ITreeChild,
	ITreeFactoryOption,
	IDataLayerItem,
	IDataLayerItemItem,
	DisclaimerItem
} from '@/types';

export const env = getEnv();

export interface SendCampaignAnalyticsButtonClick {
	event: "click_button",
	enquiry_type: string, // Optional field
	button_name: string,
	interaction_type: string,
	marketing_offer_id: string, // Optional Field
	vehicle_model: string // O
}
export function bindCampaignAnalytics() {
	Array.from(document.querySelectorAll('a[data-campaign-analytics],a[data-fsl-analytics]')).forEach((el1: Element) => {
		const el = el1 as HTMLAnchorElement;
		el.addEventListener('click', (e: MouseEvent) => {
			const ds = (e.target as HTMLAnchorElement).dataset;
			const obj: SendCampaignAnalyticsButtonClick = {
				event: "click_button",
				enquiry_type: ds.enquiryType || "",
				button_name: ds.buttonName || "",
				interaction_type: ds.interactionType || "", 
				marketing_offer_id: ds.marketingOfferId || "",
				vehicle_model: ds.model || ds.vehicleModel || ""
			}
			for (const k in obj) {
				if (!(obj as any)[k]){
					delete (obj as any)[k];
				}
			}
			if (!e.shiftKey && !e.ctrlKey) {
				e.preventDefault();
			}
			sendCampaignAnalyticsButtonClick(obj);
			if (!e.shiftKey && !e.ctrlKey) {
				setTimeout(() => {
					const href = el.getAttribute('href');
					(window as any).location = href;
				}, 100);
				e.preventDefault();
			}
		});
	});
}
export function sendCampaignAnalyticsButtonClick(args: SendCampaignAnalyticsButtonClick): void {
	const dataLayer = (window as any).dataLayer || [];
	const obj: SendCampaignAnalyticsButtonClick = {
		'event': 'click_button',
		'enquiry_type': args.enquiry_type || '', // Optional field
		'button_name': args.button_name || '',
		'interaction_type': args.interaction_type || '', // actually data-button-name
		'marketing_offer_id': args.marketing_offer_id || '', // Optional Field
		'vehicle_model': args.vehicle_model || '' // Optional Field
	};
	console.log(obj);
	dataLayer.push(obj);
}
function appendGradesAndReturnChild(children: Array<ITreeChild>, grades: Array<string>): Array<ITreeChild> {
	const newChildren: Array<Array<ITreeChild>> = [];
	children.forEach((child: ITreeChild) => {
		if (child.Children) {
			newChildren.push(child.Children);
		}
		child.Grades.forEach((o: ITreeFactoryOption) => {
			grades.push(o.Grade);
		});
	});
	return newChildren.flatMap(o => o);
}
export function getAllGradesFromTree(tree: ITree): Array<string> {
	if (!tree?.SpecNode?.Children) return [];
	const grades: Array<string> = [];
	let children: Array<ITreeChild> | null = tree.SpecNode.Children || [];
	while (children.length){
		children = appendGradesAndReturnChild(children, grades);
	}
	return grades;
}
function appendVehicleAndReturnChild(children: Array<ITreeChild>, factoryOptions: Array<ITreeFactoryOption>): Array<ITreeChild> {
	const newChildren: Array<Array<ITreeChild>> = [];
	children.forEach((child: ITreeChild) => {
		if (child.Children) {
			newChildren.push(child.Children);
		}
		child.Grades.forEach((o: ITreeFactoryOption) => {
			factoryOptions.push(o);
		});
	});
	return newChildren.flatMap(o => o);
}
export function getNewFactoryOptionArrayFromTree(tree: ITree): Array<ITreeFactoryOption> {
	if (!tree?.SpecNode?.Children) return [];
	const factoryOptions: Array<ITreeFactoryOption> = [];
	let children: Array<ITreeChild> | null = tree.SpecNode.Children || [];
	while (children.length){
		children = appendVehicleAndReturnChild(children, factoryOptions);
	}
	return factoryOptions;
}

export function initCmsScripts(): void {
	const readMoreContainers: Array<HTMLElement> = Array.from(document.querySelectorAll('.details-description .details-desc-more'));
	readMoreContainers.forEach((container: HTMLElement, i: number) => {
		container.setAttribute('style', `max-height:${container.offsetHeight}px;`);
		container.setAttribute('aria-hidden', 'true');
		container.setAttribute('id', `details-desc-more-${i}`);
		const readMore: HTMLElement | null = container.nextElementSibling as HTMLElement | null;
		
		if (!readMore) return;
		if (!readMore.classList.contains('more')) return;
		const readMoreButton = readMore.querySelector('a');
		if (!readMoreButton) return;

		readMoreButton.setAttribute('aria-pressed', 'false');
		readMoreButton.setAttribute('aria-controls', `details-desc-more-${i}`);
		readMoreButton.addEventListener('click', function(e: Event){
			e.preventDefault();
			const isPressed = this.getAttribute('aria-pressed') == 'true';
			this.setAttribute('aria-pressed', (!isPressed).toString().toLowerCase());
			container.setAttribute('aria-hidden', isPressed.toString().toLowerCase());

			const plusminus = this.querySelector('span');
			if (!plusminus) return;
			plusminus.innerHTML = isPressed ? '+' : '-';
		});
	});
}
export function getTprHref(vsid: number, m: string, tpr_source: number | null): string {
	return`/finance/get-tpr?v=${vsid}&m=${m}&tpr_source=${tpr_source}`;
}
export function getEnv(): EEnv {
	return location.href.includes("//qa.dealer") ? EEnv.qa : location.href.includes("localhost:") || location.href.includes('//test.dealer') ? EEnv.staging : EEnv.live;
}
export function setHeaderScrollClass(headerClass: string, overviewClass: string): void {
	const y = window.scrollY;
	const headerEl = document.querySelector(headerClass);
	const overviewEl = document.querySelector(overviewClass);
	const listingEl = document.getElementById('nvi-listing-header');
	const listingHeight = listingEl ? listingEl.clientHeight : 0;
	const headerHeight = headerEl ? headerEl.clientHeight : 0;
	const overviewY = overviewEl ? overviewEl.getBoundingClientRect().top : 0;
	const isSticky = y + headerHeight >= overviewY;

	if (!headerEl || !overviewEl) return;

	headerEl.classList.toggle('tb-sticky', isSticky);
	headerEl.classList.toggle('tb-hidden', isSticky);
	headerEl.setAttribute('style', `top:${listingHeight}px`);
	setTimeout(() => {
		headerEl.classList.remove('tb-hidden');
	}, 10);
}
export function isPillInPage(text: string){
	const pills = document.querySelectorAll('.tb-price-block [class^="tb-pill="], .tb-finance-block-pills [class^="tb-pill="]');
	if (!pills) return false;
	
	let isFound = false;
	for (let i = 0; i != pills.length; ++i){
		const t = (pills[i] as HTMLSpanElement).innerHTML.trim();
		if (t == text){
			isFound = true;
			break;
		}
	}
	return isFound;
}
export function bindJwAnalytics(): void {
	console.log('bindJwAnalytics', typeof (window as any).jwplayer);
	if (typeof (window as any).jwplayer == 'undefined') return;
	if (typeof (window as any).jwplayer().on == 'undefined') return;
	(window as any).jwplayer().on('play', function() {
		const current = (window as any).jwplayer().getPlaylistItem();
		(window as any).dataLayer.push({
			event: "video_start",
			video_title: current.title,
			video_url: current.file
		})
	});
	(window as any).jwplayer().on('complete', function() {
		const current = (window as any).jwplayer().getPlaylistItem();
		(window as any).dataLayer.push({
			event: "video_complete",
			video_title: current.title,
			video_url: current.file
		})
	});
}
export function getRoots(): IRoots {
	return {
		topbarRoot:  document.getElementById('detail-topbar-root'),
		headerRoot:  document.getElementById('detail-header-root'),
		bannerRoot:  document.getElementById('detail-banner-root'),
		overviewCtaRoot: document.getElementById('detail-overview-cta-root'),
		demoNavRoot: document.getElementById('detail-demo-nav-root'),
		imageGalleryRoot: document.getElementById('detail-image-gallery-root'),
		videoGalleryRoot: document.getElementById('detail-video-gallery-root'),
		cubeRoot: document.getElementById('detail-cube-root'),
		formRoot: document.getElementById('detail-form-root'),
		advantageRoot: document.getElementById('detail-advantage-root'),
		similarRoot: document.getElementById('detail-similar-root'),
		tdlRoot: document.getElementById('test-drive-lead-root'),
		tdlCustomRoot: document.getElementById('test-drive-lead-custom-root'),
		fslContentRoot: document.getElementById('fsl-content-root')
	};
}
function sendStaticFslToggleAnalytics(isFsl: boolean){
	const dl: Array<IDataLayerItem> = (window as any).dataLayer || [];
	const vehicle_arr: Array<IDataLayerItemItem> = dl.filter(o => o.event == 'view_item').flatMap(o => o.items || []);

	const new_toggle_state = isFsl ? 'full service lease' : 'finance';
	const has_tpr_applied = getCookie('tprguid') ? 'True' : 'False';
	const tpr_case_id = getCookie('tprcaseid');
	const vehicle_model = vehicle_arr.length ? vehicle_arr[0].item_category2 : ''; 
	const vehicle_grade = vehicle_arr.length ? vehicle_arr[0].item_category3 : '';
	
	dl.push({
		event: "toggle",
		toggle_name: "Full Service Lease",
		new_toggle_state,
		has_tpr_applied,
		page_type: "New Vehicle Inventory Details Page",
		tpr_case_id,
		vehicle_franchise: "Toyota",
		vehicle_model,
		vehicle_grade,
		filters: []
	});
}
export const fslDisclaimerArray: Array<DisclaimerItem> = [
	{
		for: '',
		type: 'fsl',
		key: '[F10]',
		text: 'Upgrade subject to eligibility and lending criteria. Terms, conditions, fees and charges apply.'
	},
	{
		for: '',
		type: 'fsl',
		key: '[F11]',
		text: 'Terms, conditions and insurance excess applies, refer to the Full-Service Lease Insurance Guide for details available from https://www.toyota.com.au/car-finance/full-service-lease . Toyota Finance Australia Limited (TFA) has arranged insurance cover under a master Policy for Lessees (and their authorised Drivers) who have entered into a Full-Service Lease. TFA is the holder of the Policy and cover is extended to Lessees and their authorised Drivers.'
	},
	{
		for: '',
		type: 'fsl',
		key: '[TF3]',
		text: 'Toyota Roadside Assist is administered by Toyota Finance, a division of Toyota Finance Australia Limited ABN 48 002 435 181, AFSL and Australian Credit Licence 392536.'
	}
];
export function toggleFslDisclaimers(show: boolean){
	const disclaimerContent = document.querySelector('.tb-detail-disclaimers .content')
	const disclaimers = disclaimerContent?.querySelectorAll('p[data-type="fsl"]') || [];
	if (show) {
		fslDisclaimerArray.forEach((item) => {
			const p = document.createElement('p');
			p.setAttribute('data-type', 'fsl');
			p.innerHTML = `${item.key} ${item.text}`;
			disclaimerContent?.appendChild(p);
		});
	}
	else {
		disclaimers.forEach(el => el.parentNode?.removeChild(el));
	}
}
export function bindStaticHeader(){
	let sendAnalytics = true;
	const fslToggle = document.querySelector('.tb-fsl-toggle');
	if (fslToggle){
		fslToggle.addEventListener('click', function(e: Event){
			const btn = fslToggle;
			const isPressed = btn.getAttribute('aria-checked') == "true";
			btn.setAttribute('aria-checked', (!isPressed).toString().toLowerCase());

			const header = document.querySelector('.tb-detail-header');
			header?.classList.toggle('tb-is-fsl', !isPressed);

			const normFinanceOffer = document.querySelector(`.tb-offer-text-type-${EOfferType.FinanceText}`);
			const fslFinanceOffer = document.querySelector(`.tb-offer-text-type-${EOfferType.FinanceFsl}`);
			const normContent = document.querySelector('.tb-finance-block');
			const fslContent = document.getElementById('fsl-content-root');
			
			normFinanceOffer?.setAttribute('aria-hidden', (!isPressed).toString().toLocaleLowerCase());
			fslFinanceOffer?.setAttribute('aria-hidden', isPressed.toString().toLocaleLowerCase());
			normContent?.setAttribute('aria-hidden', (!isPressed).toString().toLocaleLowerCase());
			fslContent?.setAttribute('aria-hidden', isPressed.toString().toLocaleLowerCase());

			const dateexp = new Date();
			dateexp.setDate(dateexp.getDate() + 400);//chrome limit apparently.
			const expires = "expires="+ dateexp.toString();
			const cookieData = ";" + expires + ';path=/';
			document.cookie = "selectedFinanceType=" + `${!isPressed ? 'fsl' : 'finance'}` + cookieData;

			if (sendAnalytics) {
				sendStaticFslToggleAnalytics(!isPressed);
			}
			toggleFslDisclaimers(!isPressed);
			
			e.preventDefault();
		});

		const availableFinanceTypes = (window as any).AvailableFinanceTypes || [];
		const preferredFinanceType = getCookie('selectedFinanceType') || '';
		const defaultFinanceType = (window as any).DefaultFinanceType || '';
		const initialFinanceType = preferredFinanceType && availableFinanceTypes.includes(preferredFinanceType) ? preferredFinanceType : defaultFinanceType.value;
		const selected = initialFinanceType || EFinaceToggleTypes.finance;
		const checked = (selected == EFinaceToggleTypes.fsl).toString().toLowerCase();
		const shouldTrigger = fslToggle.getAttribute('aria-checked') != checked;
		if (shouldTrigger){
			sendAnalytics = false;

			const evt = new Event('click');
			fslToggle.dispatchEvent(evt);
			setTimeout(() => {
				sendAnalytics = true;
			}, 250);
		}
	}

	const openClose = document.querySelector('.tb-detail-header-toggle');
	if (openClose){
		openClose.addEventListener('click', function(e: Event){
			const btn = openClose;
			const isPressed = btn.getAttribute('aria-pressed') == "true";
			btn.setAttribute('aria-pressed', (!isPressed).toString().toLowerCase());
			const id = btn.getAttribute('aria-controls');
			if (!id) return;
			const controlled = document.getElementById(id);
			if (!controlled) return;
			controlled.setAttribute('aria-hidden', isPressed.toString().toLowerCase());
			e.preventDefault();
		});
	}

	const bookatestdrive = document.querySelector('.tb-detail-header a[href="#detail-form-root"]');
	if (bookatestdrive){
		let doHandleLoad = false;
		let hasLoadedAll = false;

		const doScroll = (el: HTMLElement) => {
			window.scrollTo({
				top: el.offsetTop, 
				behavior: 'smooth'
			});
		};
		const handleLoaded = () => {
			const el: HTMLElement | null = document.getElementById('detail-form-root');
			if (hasLoadedAll || !doHandleLoad || !el) return;

			hasLoadedAll = true;
			setTimeout(() => {
				bookatestdrive.classList.remove('is-loading');
				doScroll(el);
			}, 2500);
		};
		document.addEventListener('allSectionsLoaded', handleLoaded);

		bookatestdrive.addEventListener('click', function(e){
			if (hasLoadedAll){
				const el: HTMLElement | null = document.getElementById('detail-form-root');
				if (!el) return;

				doScroll(el);
			}
			else {
				bookatestdrive.classList.add('is-loading');
				doHandleLoad = true;
				const evt = new CustomEvent('loadAllSections');
				document.dispatchEvent(evt);
			}
			e.preventDefault();
		});
	}

	const buyonlines = document.querySelectorAll('.tb-detail-header a[data-button-name="detail : order online"]');
	buyonlines.forEach(b => {
		b.addEventListener('click', function(e: Event){
			const el = e.target as HTMLElement;
			if (!el) return;
			
			const w = (window as unknown as IWindowScripts);
			const sb = w.specBuilder;
			const href = el.getAttribute('href') || '';
			const target = el.getAttribute('target') || '_self';
			const dataLayer = (window as any).dataLayer || [];
			const model = sb.VehicleLine;
			const grade = sb.Grade;
			const m = `${sb.CurrentVariantCode}${sb.RoofCode || sb.TrimCode}`;
			const driveaway = '(not set)';

			dataLayer.push({
				event:"add_to_cart",
				has_tpr_applied: sb.HasTprApplied ? 'Yes' : 'No',
				// Note if Vehicle Grade is not selected then the value should be ALL
				item_list_id: `nvi_${model}_${grade}`, 
				item_list_name: `New Vehicles - ${model} - ${grade}`,
				items: [
					{
						item_id: m || '(not set)',
						item_name: sb.FullDescription || '(not set)',
						item_brand: "Toyota",
						item_category: "New Vehicles",
						item_category2: sb.VehicleLine || '(not set)',
						item_category3: sb.Grade || '(not set)',
						item_category4: sb.VehicleType || '(not set)',
						price: driveaway,
						quantity: 1,
					}
				],
				page_type: sb.PageType,
				tpr_case_id: sb.FactoryOption,
			});

			setTimeout(() => {
				window.open(href, target);
			},100);

			e.preventDefault();
		});
	});
}
export function getSubmitFormImage(vehicleImages: IVehicleImages, demoImages: Array<string>): string {
	const imgExt = getImages(vehicleImages.Path_Ext, 1920, EImageExtensions.jpg);
	let img = '';
	imgExt.every(o => {
		if (o.includes('Front_34')) {
			img = o;
			return false;
		}
		return true;
	});
	if (!img){
		const imgHero = getImages(vehicleImages.Path_Hero.filter(o => o.heroDesc == 'FR34'), 1920, EImageExtensions.jpg);
		img = imgHero.length ? imgHero[0] : '';
	}
	if (!img){
		const img360 = getImages(vehicleImages.Path_360, 1920, EImageExtensions.jpg);
		// todo logic for fr34
		img = img360.length ? img360[0] : '';
	}
	if (!img){
		const imgInt = getImages(vehicleImages.Path_Int, 1920, EImageExtensions.jpg);
		img = imgInt.length ? imgInt[0] : '';
	}
	if (!img && demoImages.length){
		img = getDemoImage(demoImages[0], 1920) || '';
	}
	return img;
}
export function convertFactoryOptionToTestDriveOption(factoryOption: ITreeFactoryOption): ITestDriveOption {
	const pto = factoryOption.PaintTrimInfos.length ? factoryOption.PaintTrimInfos[0] : null;
	const transmissionType = '(not set)';
	const manufacturedYear = factoryOption.ManufacturedYear;
	const obj =  {
		Model: factoryOption.Model || '',
		Grade: factoryOption.Grade || '',
		FullDescription: factoryOption.FullDescription,
		VariantCode: '',
		Image: '',
		PaintName: pto?.PaintDescription || '(not set)',
		TrimName: pto?.TrimDescription || '(not set)',
		TransmissionType: transmissionType,
		FactoryOptionDescription: factoryOption.FactoryOptionDescription || '',
		Fuel: "(not set)",
		GradeLevelDescription: null,
		Vin: '(not set)',
		VehicleSpecificationID: -1,
		Produced: "(not set)",
		Available: true,
		Material: factoryOption.MaterialCode || '',
		Batch: '(not set)',
		ManufacturedYear: !isNaN(manufacturedYear) ? manufacturedYear : 0,
		Rego: '',
		Location: "(not set)",
		IsTfy: false,
	};
	return obj;
}
export function convertVehicleToTestDriveOption(vehicle: IVehicle, vehicleImages: IVehicleImages): ITestDriveOption {
	const sb = (window as unknown as IWindowScripts).specBuilder;
	// const transmissionType = sb.FullDescription.includes('Automatic') ? 'Automatic' : sb.FullDescription.includes('Manual') ? 'Manual' : '(not set)';
	const transmissionType = vehicle.Transmission || '(not set)';
	const manufacturedYear = parseInt(vehicle.Year || '');
	const obj =  {
		Model: vehicle.VehicleLine || '',
		Grade: vehicle.Grade || '',
		FullDescription: vehicle.FullDescription,
		VariantCode: vehicle.VariantCode,
		Image: getSubmitFormImage(vehicleImages, []),
		PaintName: vehicle.Paints ? vehicle.Paints.filter(o => o.PaintCode == vehicle.PaintCode).map(o => o.PaintName).toString() || '' : '',
		TrimName: vehicle.Trims ? vehicle.Trims.filter(o => o.TrimCode == vehicle.TrimCode).map(o => o.TrimName).toString() || '' : '',
		TransmissionType: transmissionType,
		FactoryOptionDescription: vehicle.FactoryOption || '',
		Fuel: "(not set)",
		GradeLevelDescription: null,
		Vin: vehicle.Vin || '(not set)',
		VehicleSpecificationID: vehicle.VsId,
		Produced: "(not set)",
		Available: true,
		Material: `${vehicle.CurrentVariantCode}${vehicle.TrimCode}${vehicle.PaintCode}` || '',
		Batch: vehicle.Batch || '(not set)',
		ManufacturedYear: !isNaN(manufacturedYear) ? manufacturedYear : 0,
		Rego: vehicle.Rego || '',
		Location: "(not set)",
		IsTfy: false,
	};
	return obj;
}
export function removeWhiteSpaceFromTextNodeAndNormalize(parentEl: ChildNode, normalize: boolean){
	for (const el of parentEl.childNodes){
		if (el.nodeType === Node.TEXT_NODE){
			if (el.nodeValue){
				el.nodeValue = el.nodeValue.replace(/^\s+$/g, '');
			}
		}
		else {
			removeWhiteSpaceFromTextNodeAndNormalize(el, false);
		}
	}
	normalize && parentEl.normalize();
}
export function getAdvantageData(): Array<IAdvantageDataItem> {
	const data: Array<IAdvantageDataItem> = [];
	let i = 0;

	while (i != -1){
		const titleEl = document.getElementById(`tb-advantage-title-${i}`);
		const ctaEl = document.getElementById(`tb-advantage-cta-${i}`);
		const thumbEl = document.getElementById(`tb-advantage-thumb-${i}`);
		const thumbTextEl = document.getElementById(`tb-advantage-thumbtext-${i}`);
		const rteEl = document.getElementById(`tb-detail-advantage-modal-ref-${i}`);

		const rteScriptsArray = [];
		const rteScripts = rteEl?.querySelectorAll('script');
		if (rteScripts){
			for (let x = 0; x != rteScripts.length; ++x){
				rteScriptsArray.push(rteScripts[x]);
			}
		}

		if (titleEl){
			const classEl = ctaEl?.closest('button');
			data.push({
				title: titleEl?.innerHTML || '',
				cta: ctaEl?.querySelector('span')?.innerHTML || '',
				sliderClasses: classEl?.getAttribute('class') || '',
				thumb: thumbEl?.getAttribute('src') || '',
				thumbText: thumbTextEl?.innerHTML || '',
				rte: rteEl?.innerHTML || '',
				rteScripts: rteScriptsArray, 
				analyticsName: rteEl?.dataset.analyticsName || ''
			});
			++i;
		}
		else {
			i = -1;
		}
	}
	return data;
}
export function getDateForApi(d: Date): string {
	return `${d.getFullYear()}-${("0" + (d.getMonth()+1)).slice(-2)}-${("0" + (d.getDate())).slice(-2)}`;
}
function removeDisclaimers(disclaimerHolder: HTMLElement){
	const disclaimers = (disclaimerHolder as any).querySelectorAll('p');

	for (let i = 0; i != (disclaimers as any).length; ++i){
		const el = (disclaimers as any)[i];

		if (el.getAttribute('data-dynamic-disclaimer')){
			(disclaimerHolder as any).removeChild(el);
		}
	}
}
function addDisclaimers(disclaimerHolder: HTMLElement, p: IVehiclePricing){
	const newDisclaimers: Array<INewDisclaimer> = [];

	if (p.isNationalSpecial){
		if (p.specialItem?.Disclaimers?.length){ // Get Driveaway disclaimer
			for (let i = 0; i < p.specialItem.Disclaimers.length; i++){
				if (
					p.specialItem.Disclaimers[i].Type == ESpecialItemDisclaimerTypes.driveaway || 
					p.specialItem.Disclaimers[i].Type == ESpecialItemDisclaimerTypes.special
				){
					newDisclaimers.push({
						key: p.specialItem.Disclaimers[i].Key,
						text: p.specialItem.Disclaimers[i].Value
					});
				}
			}
		}
	}
	if (p.financeDisclaimer){
		newDisclaimers.push({
			key: p.financeDisclaimerKey,
			text: p.financeDisclaimer
		});
	}
	if (p.Offers.length){
		p.Offers.forEach(o => {
			o.disclaimers.forEach(d => {
				newDisclaimers.push({
					key: d.Key,
					text: `[${d.Key}] ${d.Value}`
				});
			});
		});
	}
	for (let x = 0; x != newDisclaimers.length; ++x){
		const newP = document.createElement('p');
		newP.setAttribute('data-dynamic-disclaimer', newDisclaimers[x].key);
		newP.innerHTML = newDisclaimers[x].text;
		(disclaimerHolder as any).appendChild(newP);
	}
}
export function refreshDisclaimers(p: IVehiclePricing): void {
	const disclaimerHolder = document.querySelector('.tb-detail-disclaimers .content');
	if (!disclaimerHolder) return;
	removeDisclaimers((disclaimerHolder as HTMLElement));
	addDisclaimers((disclaimerHolder as HTMLElement), p);
}
export function nth(d: number) {
	if (d > 3 && d < 21) {
		return 'th';
	}
	switch (d % 10) {
		case 1:
			return "st";
		case 2:
			return "nd";
		case 3:
			return "rd";
		default:
			return "th";
	}
}
export function getDisclaimerKey(item: IVehiclePricing): string {
	let driveawayDisclaimerKey = '*';
	if (item.specialDisclaimerKey.length > 0) {
		driveawayDisclaimerKey = item.specialDisclaimerKey;
	}
	return driveawayDisclaimerKey;
}
export function shouldShowPricing (matchedItem: IVehiclePricing): boolean {
	const hasSpecialPrice = !!matchedItem.specialItem?.SpecialPrice;
	let shouldShowPricing = false;
	const hasSpecialExtra = !!matchedItem.specialItem?.SpecialExtra;
	if (matchedItem.isCabChassis && hasSpecialExtra && hasSpecialPrice) {
		// Is Cab-Chassis and has a special extra - so show pricing
		shouldShowPricing = true;
	} else if (matchedItem.isCabChassis && matchedItem.isDealerSpecial && matchedItem.specialApplied.length > 0) {
		shouldShowPricing = true;
	} else if (!matchedItem.isCabChassis && matchedItem.driveaway !== 'Talk to us today for a price' && matchedItem.driveaway !== 'Talk to us about tray options and price') {
		// Isn't a Cab-Chassis - so show pricing
		shouldShowPricing = true;
	}
	if (matchedItem.driveaway === 'Talk to us today for a price' || matchedItem.driveaway === 'Talk to us about tray options and price' || matchedItem.isZeroPrice) {
		shouldShowPricing = false;
	}
	return shouldShowPricing;
}
export function getTimesFromDay(date: Date, et: IEnabledTimes): Array<ITimePickerVal> {
	const day: string = date.toLocaleDateString('en-AU', { weekday: 'long' }).toLowerCase();
	const todayTimes: Array<ITimePickerVal> = (et as any)[day];
	return todayTimes;
}
export function getAmendedTimes(timeArray: Array<number>, minuteModifier: number, roundingModified: number): ITimePickerVal {
	const blank: ITimePickerVal = { hours: 0, minutes: 0 };
	if (!timeArray || timeArray.length < 2) return blank;

	const t = new Date();
	t.setHours(timeArray[0]);
	t.setMinutes(timeArray[1]);
	t.setMinutes(t.getMinutes() + minuteModifier);
	const roundingMinus = t.getMinutes() % roundingModified;

	return {
		hours: t.getHours(),
		minutes: t.getMinutes() - roundingMinus
	};
}
export function convertHourInfoItemToEnabledTimes(openingInfo: Array<IOpeningInfoItem>): IEnabledTimes {
	const blank = { hours: 0, minutes: 0 };
	const blankEnabledTimes: IEnabledTimes = {
		monday: [blank],
		tuesday: [blank],
		wednesday: [blank],
		thursday: [blank],
		friday: [blank],
		saturday: [blank],
		sunday: [blank],
	};
	const newEnabledTimes: IEnabledTimes = {
		monday: [],
		tuesday: [],
		wednesday: [],
		thursday: [],
		friday: [],
		saturday: [],
		sunday: [],
	}
	if (!openingInfo.length) return blankEnabledTimes;
	openingInfo.forEach((times: IOpeningInfoItem): void => {
		const startArray: Array<string> = times.OpeningTime.split(':');
		const closeArray: Array<string> = times.ClosingTime.split(':');
		if (startArray.length < 2 || closeArray.length < 2) return;

		const startHour: number = parseInt(startArray[0]);
		const startMinute: number = parseInt(startArray[1]);
		const closeHour: number = parseInt(closeArray[0]);
		const closeMinute: number = parseInt(closeArray[1]);
		if (isNaN(startHour) || isNaN(startMinute) || isNaN(closeHour) || isNaN(closeMinute)) return;

		const openTime: ITimePickerVal = getAmendedTimes([startHour, startMinute], 0, 30);
		const closeTime: ITimePickerVal = getAmendedTimes([closeHour, closeMinute], -30, 30);
		if (!closeTime || !openTime) return;

		(newEnabledTimes as any)[times.Day.toLowerCase()] = [openTime, closeTime];
	});
	return newEnabledTimes;
}
export function get360DefaultNum(images: Array<string>, defaultFrame: string){
	if (!images.length) return 0;
	if (images.length == 16){
		return 4;
	}
	if (images.length == 36){
		return 9;
	}
	else {
		const img = defaultFrame.split('/').pop()?.split('.')[0].split('_').pop() || '';
		const imgArr: Array<boolean> = images.map(o => -1 != o.indexOf(img));
		return imgArr.indexOf(true);
	}
}
export function get360Images(images: Array<IVehicleImage360>, screenSize: number)
{
	const imgs = getImages(
		images, 
		screenSize, 
		EImageExtensions.jpg, 
		EFrameType.full
	);
	if (imgs.length) return imgs;
	const imgsFallback1 = getImages(
		images, 
		screenSize, 
		EImageExtensions.jpg
	);
	return imgsFallback1;
}
export function isValidPhone (value: string) {
	const r = RegExp('^0[4,2,3,7,8]');
	if (
		!!value && 
		value.length == 10 && 
		r.test(value)
	) {
        return true;
    }
    return false;
}

export function isEmail (value: string) {
	// eslint-disable-next-line
  let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(value);
}

export function getFinanceHeadings(text: string): Array<string> {
	const h  = text.replace(/\. /g, ".\n").replace(/ and a /g, ".\n");
	return h.split('\n').filter(o => !!o).map(o => o.charAt(0).toUpperCase() + o.slice(1));
}

export function getCookie (sName: string): string {  
	const oCrumbles: Array<string> = document.cookie.split(';');
	for(let i = 0; i < oCrumbles.length; i++){
		const oPair= oCrumbles[i].split('=');
		const sKey = decodeURIComponent(oPair[0].trim());
		const sValue = oPair.length>1 ? oPair[1] : '';
		if(sKey == sName) {
			return decodeURIComponent(sValue);
		}
	}
	return '';
}

type TGetImage = IVehicleImage | IVehicleImage360 | IVehicleImageHero;

export function getCorrectImageSize(
	sizes: Array<string>, 
	screenSize: number
): string {
	let defaultSize = sizes.length ? sizes[sizes.length-1] : '';
	const pixelRatio = Math.ceil(window.devicePixelRatio);
	const pixelSize = screenSize * pixelRatio;

	for (let i = sizes.length-1; i != -1; --i){
		const s = parseInt(sizes[i].split('x')[0]);
		if (s >= pixelSize) {
			defaultSize = sizes[i];
			break;
		}
		else continue;
	}
	return defaultSize;
}
export const getDemoImage = (url: string, newSize: number): string => {
	const searchStr = 'demo-image-resize/'
	const sPos = url.indexOf(searchStr);
	const ePos = url.indexOf('x/');
	const originalSize = url.substring(sPos+searchStr.length, ePos);
	return url.replace(originalSize, newSize.toString());
}
export const getImages = (
	array: Array<TGetImage>, 
	screenSize: number, 
	ext: EImageExtensions, 
	frameType?: EFrameType, 
): Array<string> => {
	return array.filter((o: TGetImage) => !frameType || (o as any).frameType == frameType)
	.flatMap((o: TGetImage): Array<string> => {
		const arr = [];
		const beforeSize = ext == EImageExtensions.mp4 ? '' : `/${ext}/lo`;
		for (let i = 0; i != ((o as any).spinCount || 1); ++i){
			const size = getCorrectImageSize(o.Sizes, screenSize);
			const frameNum = (o as any).spinCount ? (i/1000).toFixed(3).replace('0.', '') : '';
			const img = `${location.protocol}${o.Path}${beforeSize}/${size}/${o.Prefix}${frameNum}.${ext}`;
			arr.push(img);
		}
		return arr;
	});
};

type IArrayOfAllFakes = Array<IFakePaintEl> | Array<IFakeTrimEl> | Array<IFakeRoofEl>;
const remApplicable = (arr: IArrayOfAllFakes): void => {
	arr.forEach(o => {o.isinactive = false});
};
const remMatches = (arr: IArrayOfAllFakes): void => {
	arr.forEach(o => {o.matches = false});
};
const isApplicablePaint = (arr: Array<IFakeRoofEl>, code: string): void => {
	arr.forEach(o => {
		if (o.applicablepaint.includes(code)){
			o.matches = true;
		}
	});
};
const isApplicable = (arr: IArrayOfAllFakes, code: string): void => {
	arr.forEach(o => {
		if (o.applicable.includes(code)){
			o.matches = true;
		}
	});
};
const isntApplicable = (arr: IArrayOfAllFakes): void => {
	arr.forEach(o => {
		if (!o.matches){
			o.isinactive = true;
		}
	});
};
const getBlankFakeColourElements = (vehicle: IVehicle): IFakeColourElements => {
	const paints: Array<IFakePaintEl> = vehicle.Paints.map(o => {
		return {
			paintcode: o.PaintCode,
			paintname: o.PaintName,
			vc: o.Vc,
			swatch: o.Swatch,
			applicable: o.Applicable,
			active: o.PaintCode == vehicle.PaintCode, 
			matches: false, 
			isinactive: false
		};
	});
	const trims: Array<IFakeTrimEl> = vehicle.Trims.map(o => {
		return {
			trimcode: o.TrimCode,
			trimname: o.TrimName,
			vc: o.Vc,
			swatch: o.Swatch,
			applicable: o.Applicable,
			active: o.TrimCode == vehicle.TrimCode, 
			matches: false, 
			isinactive: false
		};
	});
	const roofs: Array<IFakeRoofEl> = vehicle.Roofs.map(o => {
		return {
			paintcode: o.PaintCode,
			roofcode: o.RoofCode,
			paintname: o.PaintName,
			vc: o.Vc,
			swatch: o.Swatch,
			applicable: o.Applicable,
			applicablepaint: o.ApplicablePaint,
			active: o.RoofCode == vehicle.RoofCode, 
			matches: false,
			isinactive: false
		};
	});
	return {
		hash: '',
		originalvariantcode: vehicle.CurrentVariantCode,
		currrentvariantcode: vehicle.CurrentVariantCode,
		paints,
		trims,
		roofs
	};
};
const getUpdatedFakeColourElementsFromPaint = (masterCode: string, fakeEls: IFakeColourElements): IFakeColourElements => {
	fakeEls.paints.filter(o => o.active).forEach(o => {o.active = false});
	let paintCode = masterCode;
	let variantCode;
	
	if (fakeEls.roofs.length){
		remApplicable(fakeEls.roofs);
		remMatches(fakeEls.roofs);
		isApplicablePaint(fakeEls.roofs, paintCode);

		fakeEls.roofs.filter(o => o.active).forEach(o => {o.active = false});
		fakeEls.roofs.filter(o => o.matches)[0].active = true;
		
		if (fakeEls.roofs.filter(o => o.active)[0].isinactive){
			fakeEls.roofs.filter(o => o.active)[0].active = false;
			fakeEls.roofs.filter(o => o.matches)[0].active = true;
		}
	}

	remApplicable(fakeEls.paints);
	remMatches(fakeEls.paints);
	remApplicable(fakeEls.trims);
	remMatches(fakeEls.trims);
	isApplicable(fakeEls.trims, paintCode);
	isntApplicable(fakeEls.trims);

	if (fakeEls.trims.filter(o => o.active)[0].isinactive){
		fakeEls.trims.filter(o => o.active)[0].active = false;
		fakeEls.trims.filter(o => o.matches)[0].active = true;
	}
	const trimcodeverified = fakeEls.trims.filter(o => o.active)[0].trimcode;
	isApplicable(fakeEls.paints, trimcodeverified);
	isntApplicable(fakeEls.paints);

	const currentPaint = fakeEls.paints.filter(o => o.paintcode == masterCode)[0];
	currentPaint.active = !currentPaint.active;
	
	if (fakeEls.roofs.length) {
		paintCode = fakeEls.roofs.filter(o => o.active)[0].roofcode;
		variantCode = fakeEls.roofs.filter(o => o.active)[0].vc;
	} else {
		paintCode = fakeEls.paints.filter(o => o.active)[0].paintcode;
		variantCode = fakeEls.paints.filter(o => o.active)[0].vc;
	}

	const trimCode = fakeEls.trims.filter(o => o.active)[0].trimcode;
	const trimVariantCode = fakeEls.trims.filter(o => o.active)[0].vc;
	const currentvariantcode = fakeEls.originalvariantcode;

	if (currentvariantcode !== trimVariantCode || currentvariantcode !== variantCode) {
		if (currentvariantcode === variantCode && currentvariantcode != trimVariantCode) {
			variantCode = trimVariantCode;
		}
	}
	fakeEls.hash = variantCode + trimCode + paintCode;
	fakeEls.currrentvariantcode = variantCode;

	return fakeEls;
};
const getUpdatedFakeColourElementsFromTrim = (masterCode: string, fakeEls: IFakeColourElements): IFakeColourElements => {
	fakeEls.trims.filter(o => o.active).forEach(o => {o.active = false});

	let trimCode = masterCode;
	let paintCode;
	let variantCode;

	remApplicable(fakeEls.paints);
	remMatches(fakeEls.paints);
	remApplicable(fakeEls.trims);
	remMatches(fakeEls.trims);
	isApplicable(fakeEls.paints, trimCode);
	isntApplicable(fakeEls.paints);

	if (fakeEls.paints.filter(o => o.active)[0].isinactive){
		fakeEls.paints.filter(o => o.active)[0].active = false;
		fakeEls.paints.filter(o => o.matches)[0].active = true;
	}

	const paintCodeVerified = fakeEls.paints.filter(o => o.active)[0].paintcode;
	isApplicable(fakeEls.trims, paintCodeVerified);
	isntApplicable(fakeEls.trims);

	fakeEls.trims.filter(o => o.active).forEach(o => {o.active = false});
	fakeEls.trims.filter(o => o.trimcode == masterCode)[0].active = true;
	
	if (fakeEls.roofs.length){
		paintCode = fakeEls.roofs.filter(o => o.active)[0].roofcode;
		variantCode = fakeEls.roofs.filter(o => o.active)[0].vc;
	} 
	else {
		paintCode = fakeEls.paints.filter(o => o.active)[0].paintcode;
		variantCode = fakeEls.paints.filter(o => o.active)[0].vc;
	}

	const trimVariantCode = fakeEls.trims.filter(o => o.active)[0].vc;
	trimCode = fakeEls.trims.filter(o => o.active)[0].trimcode;

	const currentvariantcode = fakeEls.originalvariantcode;
	if (currentvariantcode !== trimVariantCode || currentvariantcode !== variantCode) {
		if (currentvariantcode === variantCode && currentvariantcode != trimVariantCode) {
			variantCode = trimVariantCode;
		}
	}
	fakeEls.hash = variantCode + trimCode + paintCode;
	fakeEls.currrentvariantcode = variantCode;

	return fakeEls;
};
const getUpdatedFakeColourElementsFromRoof = (masterCode: string, fakeEls: IFakeColourElements): IFakeColourElements => {
	fakeEls.roofs.filter(o => o.active).forEach(o => {o.active = false});
	const paintCode = fakeEls.roofs.filter(o => o.roofcode == masterCode)[0].roofcode;

	fakeEls.roofs.filter(o => o.active).forEach(o => {o.active = false});
	fakeEls.roofs.filter(o => o.roofcode == masterCode)[0].active = true;

	const trimCode = fakeEls.trims.filter(o => o.active)[0].trimcode;
	let variantCode = fakeEls.roofs.filter(o => o.active)[0].vc;
	const trimVariantCode = fakeEls.trims.filter(o => o.active)[0].vc;

	const currentvariantcode = fakeEls.originalvariantcode;
	if (currentvariantcode !== trimVariantCode || currentvariantcode !== variantCode) {
		if (currentvariantcode === variantCode && currentvariantcode != trimVariantCode) {
			variantCode = trimVariantCode;
		}
	}
	fakeEls.hash = variantCode + trimCode + paintCode;
	return fakeEls;
};
const getUpdatedFakeColourElementsFromHashOrNoHash = (materialHash: string, fakeEls: IFakeColourElements): IFakeColourElements => {
	let paintCode = '';
	let trimCode = '';
	let variantCode = '';

	if (materialHash.length > 4 && !fakeEls.roofs.length){
		paintCode = materialHash.substring(13, 17);
		if (fakeEls.paints.filter(o => o.active)[0].paintcode !== paintCode){
			fakeEls.paints.filter(o => o.active)[0].active = false;
			fakeEls.paints.filter(o => o.paintcode == paintCode)[0].active = true;
		}
		trimCode = materialHash.substring(9, 13);
		remApplicable(fakeEls.paints);
		remMatches(fakeEls.paints);
		remApplicable(fakeEls.trims);
		remMatches(fakeEls.trims);
		isApplicable(fakeEls.trims, paintCode)
		isntApplicable(fakeEls.trims);

		fakeEls.trims.filter(o => o.active).forEach(o => {o.active = false});
		fakeEls.trims.filter(o => o.matches && o.trimcode == trimCode)[0].active = true;

		const trimcodeverified = fakeEls.trims.filter(o => o.active)[0].trimcode;
		isApplicable(fakeEls.paints, trimcodeverified)
		isntApplicable(fakeEls.paints);
	} else {
		paintCode = fakeEls.paints.filter(o => o.active)[0].paintcode;
	}

	if (fakeEls.roofs.length && materialHash.length > 4) {
		let colourCode = paintCode;

		if (materialHash.length > 4) {
			paintCode = materialHash.substring(13, 17);
			const foundroof = fakeEls.roofs.filter(o => o.roofcode == paintCode)[0];

			fakeEls.roofs.filter(o => o.active).forEach(o => {o.active = false});
			foundroof.active = true;

			colourCode = foundroof.applicablepaint[0];

			if (fakeEls.paints.filter(o => o.active)[0].paintcode !== colourCode){
				fakeEls.paints.filter(o => o.active)[0].active = false;
				fakeEls.paints.filter(o => o.paintcode == colourCode)[0].active = true;
			}

			trimCode = materialHash.substring(9, 13);
		}
		remApplicable(fakeEls.roofs);
		remMatches(fakeEls.roofs);
		isApplicablePaint(fakeEls.roofs, colourCode);
		if (fakeEls.roofs.filter(o => o.active)[0].isinactive){
			fakeEls.roofs.filter(o => o.active)[0].active = false;
			fakeEls.roofs.filter(o => o.roofcode == paintCode)[0].active = true;
		}
		remApplicable(fakeEls.paints);
		remMatches(fakeEls.paints);
		remApplicable(fakeEls.trims);
		remMatches(fakeEls.trims);
		isApplicable(fakeEls.trims, colourCode);
		isntApplicable(fakeEls.trims);

		if (fakeEls.trims.filter(o => o.active)[0].isinactive){
			fakeEls.trims.filter(o => o.active)[0].active = false;
			fakeEls.trims.filter(o => o.matches)[0].active = true;
		}

		const trimcodeverified = fakeEls.trims.filter(o => o.active)[0].trimcode;
		isApplicable(fakeEls.paints, trimcodeverified)
		isntApplicable(fakeEls.paints);
	}

	if (fakeEls.roofs.length && materialHash.length < 4) {
		remApplicable(fakeEls.roofs);
		remMatches(fakeEls.roofs);
		isApplicablePaint(fakeEls.roofs, paintCode);

		fakeEls.roofs.filter(o => o.active).forEach(o => {o.active = false});
		fakeEls.roofs.filter(o => o.matches)[0].active = true;

		if (fakeEls.roofs.filter(o => o.active)[0].isinactive){
			fakeEls.roofs.filter(o => o.active)[0].active = false;
			fakeEls.roofs.filter(o => o.matches)[0].active = true;
		}
		remApplicable(fakeEls.paints);
		remMatches(fakeEls.paints);
		remApplicable(fakeEls.trims);
		remMatches(fakeEls.trims);
		isApplicable(fakeEls.trims, paintCode);
		isntApplicable(fakeEls.trims);
		if (fakeEls.trims.filter(o => o.active)[0].isinactive){
			fakeEls.trims.filter(o => o.active)[0].active = false;
			fakeEls.trims.filter(o => o.matches)[0].active = true;
		}
		const trimcodeverified = fakeEls.trims.filter(o => o.active)[0].trimcode;
		isApplicable(fakeEls.paints, trimcodeverified)
		isntApplicable(fakeEls.paints);
	}
	if (materialHash.length < 4) {
		remApplicable(fakeEls.paints);
		remMatches(fakeEls.paints);
		remApplicable(fakeEls.trims);
		remMatches(fakeEls.trims);
		isApplicable(fakeEls.trims, paintCode);
		isntApplicable(fakeEls.trims);

		if (fakeEls.trims.filter(o => o.active)[0].isinactive){
			fakeEls.trims.filter(o => o.active)[0].active = false;
			fakeEls.trims.filter(o => o.matches)[0].active = true;
		}

		const trimcodeverified = fakeEls.trims.filter(o => o.active)[0].trimcode;
		isApplicable(fakeEls.paints, trimcodeverified);
		isntApplicable(fakeEls.paints);
	}
	if (fakeEls.roofs.length) {
		paintCode = fakeEls.roofs.filter(o => o.active)[0].roofcode;
		variantCode = fakeEls.roofs.filter(o => o.active)[0].vc;
	} else {
		paintCode = fakeEls.paints.filter(o => o.active)[0].paintcode;
		variantCode = fakeEls.paints.filter(o => o.active)[0].vc;
	}

	trimCode = fakeEls.trims.filter(o => o.active)[0].trimcode;
	const trimVariantCode = fakeEls.trims.filter(o => o.active)[0].vc;
	const currentvariantcode = fakeEls.originalvariantcode;

	if (currentvariantcode !== trimVariantCode || currentvariantcode !== variantCode) {
		if (currentvariantcode === variantCode && currentvariantcode != trimVariantCode) {
			variantCode = trimVariantCode;
		}
	}

	fakeEls.hash = variantCode + trimCode + paintCode;

	return fakeEls;
};
export const getUpdatedFakeColourElements = (
	masterSwatch: EToggles | null, 
	masterCode: string, 
	vehicle: IVehicle, 
	fakeColourEls: IFakeColourElements | null
): IFakeColourElements => {	
	const defaultFakeEls: IFakeColourElements = fakeColourEls ? fakeColourEls : getBlankFakeColourElements(vehicle);
	console.log('defaultFakeEls',defaultFakeEls)

	let { hash, paints, trims, roofs, currrentvariantcode, originalvariantcode } = defaultFakeEls;
	switch (masterSwatch){
		case EToggles.paint: {
			({ hash, paints, trims, roofs, currrentvariantcode, originalvariantcode } = getUpdatedFakeColourElementsFromPaint(masterCode, defaultFakeEls));
			break;
		}
		case EToggles.trim: {
			({ hash, paints, trims, roofs, currrentvariantcode, originalvariantcode } = getUpdatedFakeColourElementsFromTrim(masterCode, defaultFakeEls));
			break;
		}
		case EToggles.roof: {
			({ hash, paints, trims, roofs, currrentvariantcode, originalvariantcode } = getUpdatedFakeColourElementsFromRoof(masterCode, defaultFakeEls));
			break;
		}
		default: {
			({ hash, paints, trims, roofs, currrentvariantcode, originalvariantcode } = getUpdatedFakeColourElementsFromHashOrNoHash(masterCode, defaultFakeEls));
			break;
		}
	}
	return {
		hash,
		currrentvariantcode,
		originalvariantcode,
		paints,
		trims,
		roofs
	};
};
export const getInitialVehicle = (sb: IVehicle): IVehicle => {
	return {
		Batch: sb.Batch || '',
		VehicleLine: sb.VehicleLine,
		FullDescription: sb.FullDescription,
		FullDescriptionForFinance: sb.FullDescriptionForFinance,
		IsVirtual: sb.IsVirtual,
		VirtualVehicleId: sb.VirtualVehicleId,
		SpecificationId: sb.SpecificationId,
		VsId: sb.VsId,
		Dealer: sb.Dealer,
		BaseModelCode: sb.BaseModelCode,
		Year: sb.Year,
		PlannedMonth: sb.PlannedMonth,
		OrderEnabled: sb.OrderEnabled,
		CurrentVariantCode: sb.CurrentVariantCode,
		VariantCode: sb.VariantCode,
		PaintCode: sb.Roofs && sb.Roofs.length ? sb.Roofs.filter(o => o.RoofCode == sb.PaintCode).map(o => o.PaintCode).toString().split(',')[0] : sb.PaintCode,
		RoofCode: sb.PaintCode,
		TrimCode: sb.TrimCode,
		Paints: sb.Paints || [],
		Trims: sb.Trims || [],
		Roofs: sb.Roofs || [],

		VehicleType: sb.VehicleType,
		Vin: sb.Vin,
		Grade: sb.Grade,
		Transmission: sb.Transmission,
		HasTprApplied: sb.HasTprApplied,
		PageType: sb.PageType, 
		Price: sb.Price, 
		FactoryOption: sb.FactoryOption, 

		Rego: sb.Rego || '',
		Offers: sb.Offers || []
	};
}
const replaceSwatchImg = (img: Element, newUrl: string, alt: string): void => {
	img.setAttribute('src', newUrl);
	img.setAttribute('alt', alt);
}
const getNewSwatchData = (newVehicle: IVehicle): INewSwatchData => {
	const newPaintName = newVehicle.Roofs.length ? 
		newVehicle.Roofs
			.filter(o => o.RoofCode == newVehicle.RoofCode)
			.map(o => o.PaintName).toString() : 
		newVehicle.Paints
			.filter(o => o.PaintCode == newVehicle.PaintCode)
			.map(o => o.PaintName).toString()
		;
	const newTrimName = newVehicle.Trims
		.filter(o => o.TrimCode == newVehicle.TrimCode)
		.map(o => o.TrimName).toString();
	const newPaintUrl = newVehicle.Paints
		.filter(o => o.PaintCode == newVehicle.PaintCode)
		.map(o => o.Swatch).toString();
	const newTrimUrl = newVehicle.Trims
		.filter(o => o.TrimCode == newVehicle.TrimCode)
		.map(o => o.Swatch).toString();
	const newRoofUrl = newVehicle.Roofs
		.filter(o => o.RoofCode == newVehicle.RoofCode)
		.map(o => o.Swatch).toString();

	return {
		newPaintName,
		newPaintUrl,
		newTrimName, 
		newTrimUrl, 
		newRoofUrl
	}
};
export const changeSwatchesInDocument = (newVehicle: IVehicle): void => {
	const paintNames = document.querySelectorAll('[data-dynamic-paint-name]');
	const trimNames = document.querySelectorAll('[data-dynamic-trim-name]');
	const imgsPaint = document.querySelectorAll('[data-dynamic-paint]');
	const imgsTrim = document.querySelectorAll('[data-dynamic-trim]');
	const imgsRoof = document.querySelectorAll('[data-dynamic-roof]');
	const { newPaintName, newPaintUrl, newTrimName, newTrimUrl, newRoofUrl } = getNewSwatchData(newVehicle);

	paintNames.forEach(el => {
		el.innerHTML = newPaintName;
	});
	trimNames.forEach(el => {
		el.innerHTML = newTrimName;
	});
	imgsPaint.forEach(img => {
		replaceSwatchImg(img, `${newPaintUrl}`, newPaintName);
	});
	imgsTrim.forEach(img => {
		replaceSwatchImg(img, `${newTrimUrl}`, newTrimName);
	});
	imgsRoof.forEach(img => {
		if (newRoofUrl){
			img.closest('.tb-colour.tb-roof')?.setAttribute('style', '');
			replaceSwatchImg(img, `${newRoofUrl}`, newPaintName);
		}
		else {
			img.closest('.tb-colour.tb-roof')?.setAttribute('style', 'display:none');
		}
	});
};
export const getCodes = (fakeColourEls: IFakeColourElements): ICodes => {
	// hashMaterial.substring(0, 9) variant
	// hashMaterial.substring(9, 13) trim
	// hashMaterial.substring(13, 17) paint roof
	// return {
	// 	isValid: hash.length == 16,
	// 	variantCode: hash.substring(0, 9),
	// 	trimCode: hash.substring(9, 13), 
	// 	roofCode: roofs.length ? hash.substring(13, 17) : '', 
	// 	paintCode: roofs.length ? roofs
	// 		.filter(o => o.RoofCode == hash.substring(13, 17))
	// 		.map(o => o.ApplicablePaint).toString()
	// 	: hash.substring(13, 17)
	// };
	return {
		isValid: true,
		variantCode: fakeColourEls.currrentvariantcode,
		paintCode: fakeColourEls.paints.filter(o => o.active).map(o => o.paintcode).toString(),
		trimCode: fakeColourEls.trims.filter(o => o.active).map(o => o.trimcode).toString(),
		roofCode: fakeColourEls.roofs.filter(o => o.active).map(o => o.roofcode).toString() || ''
	};
}
export function formatPrice(p: number){
    const whole = Math.floor(p);
    const remainder = p - whole;
    const formatter = new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: remainder ? 2 : 0
    });
    return formatter.format(p);
}
// function validateRecaptcha(form, recaptcha){
//     var $recaptcha = getRecaptchaDiv(form);
//     $recaptcha.next('.field-validation-error').remove();
//     if (!recaptcha){
//         $recaptcha.after('<div class="field-validation-error">Please complete the captcha.</div>');
//         return false;
//     }
//     return true;
// }
// function resetRecaptcha(formOrButton){
//     if (typeof grecaptcha == 'undefined') return '';
//     var $recaptcha = getRecaptchaDiv(formOrButton);
//     var id = parseInt($recaptcha.attr('data-id'));
//     grecaptcha.reset(id);
// }
// function getRecaptchaDiv(formOrButton){
//     if (typeof grecaptcha == 'undefined') return '';
//     var $form = formOrButton.tagName === 'FORM' ? $(formOrButton) : $(formOrButton).closest('form');
//     return $form.find('.g-recaptcha');
// }
// function getRecaptcha(formOrButton){
//     if (typeof grecaptcha == 'undefined') return '';
//     var $recaptcha = getRecaptchaDiv(formOrButton);
//     var recaptcha = grecaptcha.getResponse(parseInt($recaptcha.attr('data-id')));
//     return recaptcha;
// }
// function recaptchaApiLoaded(){
//     var key = !location.href.includes('localhost') ? '6LfjD8EUAAAAAHWKFtKD1Yxx7HZWzOafhrUjBSbR' : '6LfN8bEUAAAAAHycQXBxTvtI-n86hl6ENhyVXqke';
//     var $recaptchas = $('.g-recaptcha');
    
//     if (grecaptcha){
//         var normalRecaptchaWidth = 304;
//         $recaptchas.each(function(){
//             var $me = $(this);
//             var id = $me.attr('id');
//             if (id){
//                 var recaptchaSize = $me.innerWidth() < normalRecaptchaWidth ? 'compact' : 'normal';
//                 var reid = grecaptcha.render(id, {
//                     'sitekey' : key,
//                     'callback' : handleRecaptchaCallback.bind(this), 
//                     'expired-callback': handleRecaptchaExpired.bind(this), 
//                     'size': recaptchaSize
//                 });
//                 $me.attr('data-id', reid);
//             }
//         });
//     }
// }
// function handleRecaptchaExpired(){
//     $(this).after('<div class="field-validation-error">Please complete the captcha.</div>');
// }
// function handleRecaptchaCallback($recaptcha){
//     $(this).next('.field-validation-error').remove();
// }